import asyncActionTypes from '../actions/types';

const initialState = {
  infoTouchPoint: [],
};

const TouchPointsLogin = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_TOUCHPOINTS_LOGIN.START:
    case asyncActionTypes.RETRIEVE_TOUCHPOINTS_LOGIN.FAIL:
      return {
        ...state,
        infoTouchPoint: [],
      };
    case asyncActionTypes.RETRIEVE_TOUCHPOINTS_LOGIN.SUCCESS:
      return {
        ...state,
        infoTouchPoint: action.payload,
      };
    default:
      return state;
  }
};

export default TouchPointsLogin;